import { makeAutoObservable } from "mobx";
import {
  pagingPatientReminderCards,
  getPatientReminderCard,
  createPatientReminderCard,
  editPatientReminderCard,
  deletePatientReminderCard,
} from "./PatientReminderCardService";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import i18n from "i18n";

export default class PatientReminderCardStore {
  patientReminderCardList = [];
  selectedPatientReminderCard = null;
  selectedPatientReminderCardList = [];
  totalElements = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 10;
  keyword = "";
  loadingInitial = false;
  shouldOpenEditorDialog = false;
  shouldOpenConfirmationDialog = false;
  shouldOpenConfirmationDeleteListDialog = false;
  resetObject = {
    keyword: "",
    active: null,
    automatic: null,
    checkDataConsistency: null,
    dailyUpdate: null,
    sortName: null,//sort tên
    sortCode: null,//sort mã
    sortContentSql: null,
  };
  searchObject = {
    keyword: "",
    active: null,
    automatic: null,
    checkDataConsistency: null,
    dailyUpdate: null,
    sortName: null,//sort tên
    sortCode: null,//sort mã
    sortContentSql: null,
  };

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  updatePageData = (item) => {
    if (item != null) {
      this.page = 1;
      this.keyword = item.keyword;
      this.search();
    } else {
      this.search();
    }
  };

  search = async () => {
    this.loadingInitial = true;
    var searchObject = {
      pageIndex: this.page,
      pageSize: this.rowsPerPage,
      keyword: this.searchObject?.keyword,
      active: this.searchObject?.active,
      automatic: this.searchObject?.automatic,
      checkDataConsistency: this.searchObject?.checkDataConsistency,
      dailyUpdate: this.searchObject?.dailyUpdate,
      sortName: this.searchObject.sortName,//sort tên
      sortCode: this.searchObject.sortCode,//sort mã
      sortContentSql: this.searchObject.sortContentSql,
    };
    try {
      let data = await pagingPatientReminderCards(searchObject);
      this.patientReminderCardList = data.data.content;
      this.totalElements = data.data.totalElements;
      this.totalPages = data.data.totalPages;
      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
      toast.warning("toast.load_fail");
      this.setLoadingInitial(false);
    }
  };

  setPage = (page) => {
    this.page = page;
    this.updatePageData();
  };

  setRowsPerPage = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageData();
  };

  handleChangePage = (event, newPage) => {
    this.setPage(newPage);
  };

  handleEditPatientReminderCard = (id) => {
    this.getPatientReminderCard(id).then(() => {
      this.shouldOpenEditorDialog = true;
    });
  };

  handleClose = () => {
    this.shouldOpenEditorDialog = false;
    this.shouldOpenConfirmationDialog = false;
    this.shouldOpenConfirmationDeleteListDialog = false;
    this.updatePageData();
  };

  handleDelete = (id) => {
    this.getPatientReminderCard(id).then(() => {
      this.shouldOpenConfirmationDialog = true;
    });
  };

  handleDeleteList = () => {
    this.shouldOpenConfirmationDeleteListDialog = true;
  };

  handleConfirmDelete = async () => {
    try {
      const res = await deletePatientReminderCard(this.selectedPatientReminderCard.id);
      if (res?.data) {
        if(res?.data.code === "-1"){
          toast.warning(i18n.t("toast.delete_fail"));
        }
        else
        toast.success(i18n.t("toast.delete_success"));
      } else {
        toast.warning(i18n.t("toast.delete_fail"));
      }
      this.handleClose();
    } catch (error) {
      console.log(error);
      toast.error(i18n.t("toast.error"));
    }
  };

  handleConfirmDeleteList = async () => {
    let listAlert = [];
    for (var i = 0; i < this.selectedPatientReminderCardList.length; i++) {
      try {
        await deletePatientReminderCard(this.selectedPatientReminderCardList[i].id);
      } catch (error) {
        listAlert.push(this.selectedPatientReminderCardList[i].name);
        toast.warning(i18n.t("toast.delete_fail"));
      }
    }
    this.handleClose();
    toast.success(i18n.t("toast.delete_success"));
  };

  getPatientReminderCard = async (id) => {
    if (id != null) {
      try {
        let data = await getPatientReminderCard(id);
        this.handleSelectPatientReminderCard(data.data);
      } catch (error) {
        console.log(error);
        toast.warning(i18n.t("toast.error"));
      }
    } else {
      this.handleSelectPatientReminderCard(null);
    }
  };

  handleSelectPatientReminderCard = (PatientReminderCard) => {
    this.selectedPatientReminderCard = PatientReminderCard;
  };

  handleSelectListPatientReminderCard = (PatientReminderCards) => {
    this.selectedPatientReminderCardList = PatientReminderCards;
    console.log(this.selectedPatientReminderCardList);
  };

  createPatientReminderCard = async (PatientReminderCard) => {
    try {
      await createPatientReminderCard(PatientReminderCard);
      toast.success(i18n.t("toast.add_success"));
      this.handleClose();
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.add_fail"));
    }
  };

  editPatientReminderCard = async (patientReminderCard) => {
    try {
      await editPatientReminderCard(patientReminderCard);
      toast.success(i18n.t("toast.update_success"));
      this.handleClose();
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.update_fail"));
    }
  };
  resetSearchObject = () => {
    this.keyword = "";
    this.page = 1;
    this.rowsPerPage = 10;
    this.searchObject = {...this.resetObject}
  }

  preHandleSubmitData = (values) => {
    return {
      ...values,
    }
  }

  handleSetSearchObject = obj => {
    this.searchObject = {...obj}
  }

  handleSetSortField = item => {
    this.page = 1;
    this.searchObject = {
      ...this.searchObject,
      //set các trường sort khác = null
      sortName: null,//sort tên
      sortCode: null,//sort mã
      sortContentSql: null,
      ...item,
    };
    this.updatePageData();
  }
}
